module.exports = __webpack_public_path__ + "static/media/ap-web-plp.18b72225.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/single-sample-modal/ap-web-plp.svg
// module id = 1274
// module chunks = 68